<template>
    <v-col cols="12" md="6" sm="6" xs="12">
        <v-select v-model="form.copier.how_many_rolls" density="compact" variant="outlined"
            label="How many rolls do you want your printer to have?"
            :items="[{title:'---',value:null},'Just 1 Roll','2 Rolls','Not sure']"/>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)
</script>
